import type { Tealium } from 'src/types/appState';

import { WRITE_CONTINUE_INTERACTION } from '../../constants';

export default (tealium: Tealium) => {
  const {
    cajaAboutBusinessCharacterCount,
    finalJobSummaryCharacterCount,
    numberOfBenefits,
    numberOfQualifications,
    numberOfTasks,
    productSetId,
  } = tealium;

  return {
    adBenefitCount: numberOfBenefits,
    adQualificationCount: numberOfQualifications,
    adProductSetId: productSetId,
    adTaskCount: numberOfTasks,
    cajaAboutBusinessCharacterCount,
    finalJobSummaryCharacterCount,
    objectInteraction: WRITE_CONTINUE_INTERACTION,
  };
};
